import React, { Component, memo } from 'react';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './ChooseTools.scss';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Footer from '../../components/Footer2';

import HelpBalloon from '../../components/Intelligence/component/HelpBalloon/HelpBalloon';
import { UserActions } from '../../store/actions/users';
import Header from '../../components/Header';
import { CompanyActions } from '../../store/actions/companies';
import imgToolCriado from '../../assets/images/icon_tool_criador.svg';
import imgToolSettings from '../../assets/images/icon_tool_settings.svg';
import imgRelatorios from '../../assets/images/relatorios.svg';
import imgPlanos from '../../assets/images/planos.png';

class ChooseTool extends Component {
  constructor(props) {
    super(props);
    const localStorageData = JSON.parse(localStorage.getItem('visibleModals'));
    this.state = {
      show: !(localStorageData && localStorageData.newFeature === 'suppress'),
    };

    const { location } = this.props;

    if (location?.search && location.search !== '') {
      this.query = queryString.parse(location.search);
    }
  }

  componentDidUpdate() {
    const { user, updateUser } = this.props;
    if (user && this.query && this.query.code) {
      const { _id } = user;
      const data = {
        _id,
        rdOAuthCode: this.query.code,
      };
      updateUser(data);
      this.query = null;
    }
  }

  handleClose() {
    const localStorageData =
      JSON.parse(localStorage.getItem('visibleModals')) || {};
    localStorageData.newFeature = 'suppress';
    localStorage.setItem('visibleModals', JSON.stringify(localStorageData));

    this.setState({ show: false });
  }

  render() {
    const { i18n, history, user } = this.props;

    return (
      <div className="container-chooseTools">
        <Header pagetype="page-inicio" />
        <div className="container-home-user">
          <div className="title-menu-principal">Menu Principal</div>
          <div
            className="col-md-12 conteudo-iniciar"
            style={{ paddingTop: 20 }}
          >
            <div
              className="card-tools card-tools-criador pointer"
              onClick={() => history.push('/bots')}
              style={{}}
            >
              <img src={imgToolCriado} alt="" />
              <span>{i18n.t('Criador')}</span>
            </div>
            {(user && user.selectedCompany?.claim?.name === 'User') ||
            (user && user.selectedCompany?.claim?.name === 'Viewer') ? (
              ''
            ) : (
              <>
                <div
                  className="card-tools card-tools-preferencias pointer"
                  onClick={() => history.push('/preferencias/organizacoes')}
                >
                  <img src={imgToolSettings} alt="" />
                  <span>{i18n.t('Preferências')}</span>
                </div>

                <div
                  className="card-tools card-tools-plano pointer"
                  onClick={() => history.push('/planos')}
                >
                  <img src={imgPlanos} alt="" />
                  <span>{i18n.t('Plano')}</span>
                </div>
                <div
                  className="card-tools card-tools-report-org pointer"
                  onClick={() =>
                    history.push(`/relatorio-org/${user.selectedCompany._id}`)
                  }
                >
                  <img src={imgRelatorios} alt="" />
                  <span>{i18n.t('Relatórios da Org.')}</span>
                </div>
              </>
            )}{' '}
          </div>
          <Footer />
        </div>

        <Modal
          show={this.state.show}
          onHide={() => this.handleClose()}
          dialogClassName="new-feature-modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span className="new-feature-modal-title">
                Novas features disponíveis!
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="new-feature-modal-body">
              Olá, {user && user.name}!<br />
              <br />
              Agora, toda vez que uma nova feature for lançada na Boteria, você
              poderá ver os detalhes{' '}
              <strong>
                passando o mouse por cima do ícone de interrogação ao lado
              </strong>{' '}
              da feature.
              <br />
              <br />
              Tente:
              <div className="new-feature-modal-body-example">
                Nova Feature
                <HelpBalloon
                  id="new_feature"
                  message="Aqui aparecerá detalhes sobre a feature."
                />
              </div>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="new-feature-modal-footer">
              <span>
                Alguma dúvida?{' '}
                <a
                  className="new-feature-modal-footer-linkFAQ"
                  target="_BLANK"
                  href="https://code7.com/faq/boteria/"
                  rel="noopener noreferrer"
                >
                  Entre no FAQ.
                </a>
              </span>
              <Button variant="primary" onClick={() => this.handleClose()}>
                Ok!
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions, ...CompanyActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(ChooseTool)))
);
